import { Component, ChangeDetectionStrategy, ViewChild, TemplateRef, ElementRef, ChangeDetectorRef, SimpleChanges, Input, Output, EventEmitter, OnInit, OnDestroy, forwardRef } from "@angular/core";
import { WLazyLoadable } from "@wipo/w-angular/directives";
import { compareSimpleArraysInOrder } from "@wipo/w-angular/shared";

@Component({
    selector: '[facet-nested-panel],[facet-nested-view-panel]',
    templateUrl: './facet-w-view-panel.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FacetWViewPanelComponent implements OnInit, WLazyLoadable {
    @ViewChild('templateTitle') templateTitle?: TemplateRef<any>;
    @ViewChild('templateInfo') templateInfo?: TemplateRef<any>;
    @ViewChild('templatePlaceholder') templatePlaceholder?: TemplateRef<any>;

    @ViewChild('templateFolded') templateFolded?: TemplateRef<any>;
    @ViewChild('templateUnfolded') templateUnfolded?: TemplateRef<any>;
    @ViewChild('templateFoldedSection') templateFoldedSection?: TemplateRef<any>;
    @ViewChild('templateUnfoldedSection') templateUnfoldedSection?: TemplateRef<any>;
    @ViewChild('templateFoldedFooter') templateFoldedFooter?: TemplateRef<any>;
    @ViewChild('templateUnfoldedFooter') templateUnfoldedFooter?: TemplateRef<any>;

    @ViewChild('templatePrimaryAction') templatePrimaryAction?: ElementRef<HTMLDivElement>;
    @ViewChild('templateFreeAction') templateFreeAction?: ElementRef<HTMLDivElement>;
    @ViewChild('templateSecondaryActions') templateSecondaryActions?: ElementRef<HTMLDivElement>;

    /** allow inputs to panel */
    @Input() facets?: string[];
    @Input() title?: string; /** title of the panel, if not provided, the title facet will be used **/
    @Input() folded: boolean = true; /* default folded state */
    @Input() type: string = ''; // provide: warning, error, important, success
    @Input() highlighted: boolean = false;
    @Input() legacy: boolean = false; // use legacy white background
    @Input() selected: boolean = false; // selected value

    /** outputs */
    @Output() selectedChange = new EventEmitter<boolean>(); // selection change
    @Output() wFolded = new EventEmitter<boolean>(true); // folded/unfolded status

    _show_facet: Record<string, boolean> = {};
    useFixedFacets: boolean = false;
    // number in outOfViewportHeight ensures lazy loading, will build only placeholder template until the element is visible
    @Input() outOfViewportHeight: number = 100; // height of the element outside of the viewport
    isLazyLoading: boolean = false; // set to true when handled by directive
    // next two fields set from view panel
    isVisible: boolean = false; // we set to true as soon as visible. And do not reset even when out ofviewport again
    visibilityChange: EventEmitter<boolean> = new EventEmitter<boolean>(true);
    // triggered once when facet becomes visible (or if provided undefined as out-of-vieport-height)
    @Output() wVisible = new EventEmitter<boolean>();
    @Output() wUpdated = new EventEmitter<void>();

    constructor(private cd: ChangeDetectorRef) { }

    saved: any;
    ngOnInit(): void {
        this.saved = this.visibilityChange;
        this.visibilityChange.subscribe({
            next: (isVisible: boolean) => {
                this.isVisible = isVisible;
                this.wVisible.emit(isVisible);
                this.cd.markForCheck();
            }
        })
        /** we do not use lazy-loading directive (no provider for W_LAZY_LOADABLE) *
         * we just use the pattern and receive event from parent panel
         * */
        if ((this.outOfViewportHeight ?? 0) === 0) {
            this.visibilityChange.emit(true); // visible if no outOfViewportHeight is provided or =0
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        /** if we set "facets" we control what is shown (using *ngIf) * */
        const facets = changes['facets'];
        if (facets && !compareSimpleArraysInOrder(facets.currentValue, facets.previousValue)) {
            this._show_facet = (this.facets || []).reduce((acc, f) => ({ ...acc, [f]: true }), {} as Record<string, boolean>);
            this.useFixedFacets = (this.facets?.length ?? 0) > 0;
            this.wUpdated.emit();
        }
    }

    // facetHasContent(name: string): boolean {
    //     const el = (this[name].elementRef.nativeElement as HTMLTemplateElement)?.content;
    //     return !!el?.children?.length || !!el?.textContent;
    // }
}